/**
 * Pure H OS · Sprint 12 · AI HQ mocks — types + live views.
 *
 * The static payload was moved to MongoDB (`pureh_ai_teammates`,
 * `pureh_playbooks`, …). What remains here is the TypeScript surface
 * every AI page is written against. Each `export const NAME`
 * transparently reads from the live store; no page code changed.
 */
import { liveArray } from "../services/store";

export type AiRole =
  | "cfo" | "coo" | "cmo" | "cto" | "chief-perfumer"
  | "chief-growth" | "chief-ops" | "chief-people";

export type AiTeammate = {
  id: string;
  role: AiRole;
  name: string;
  title: string;
  status: "on-duty" | "learning" | "paused";
  primaryModule: string;
  conversationsToday: number;
  decisionsAssisted7d: number;
  averageConfidence: number;
  motto: string;
};
export const AI_TEAMMATES: AiTeammate[] = liveArray<AiTeammate>("ai_teammates");

export type Playbook = {
  id: string;
  ownerTeammateId: string;
  name: string;
  scope: string;
  triggers: string[];
  runsThisMonth: number;
  outcomeSummary: string;
};
export const PLAYBOOKS: Playbook[] = liveArray<Playbook>("playbooks");

export type AiConversation = {
  id: string;
  teammateId: string;
  title: string;
  askedBy: string;
  askedRelative: string;
  messages: number;
  decisions: number;
  summary: string;
};
export const AI_CONVERSATIONS: AiConversation[] = liveArray<AiConversation>("ai_conversations");

export type AiInsight = {
  id: string;
  teammateId: string;
  severity: "info" | "medium" | "high";
  title: string;
  detail: string;
  createdRelative: string;
  acted: boolean;
};
export const AI_INSIGHTS: AiInsight[] = liveArray<AiInsight>("ai_insights");

export type AiApproval = {
  id: string;
  teammateId: string;
  title: string;
  amountEGP: number;
  askedBy: string;
  askedRelative: string;
  status: "pending" | "approved" | "declined";
  aiRecommendation: "approve" | "hold" | "decline";
  aiConfidence: number;
};
export const AI_APPROVALS: AiApproval[] = liveArray<AiApproval>("ai_approvals");
